import { useState } from "react";
import { parseConstitution } from "../lib/traceEvaluation.js";

export function reviewProfileDefinition(profile, kind, reference) {
    if (!profile || !reference) return null;
    if (kind === "policy") {
        const clause = parseConstitution(profile.policyText || "").find((item) => item.ref === reference);
        return clause ? { reference, title: clause.text, description: clause.text, basis: "" } : null;
    }
    const items = kind === "norms" ? profile.norms : profile.intents;
    return (items || []).find((item) => item.reference === reference) || null;
}

export default function ReviewProfileReference({ profile, kind, reference, className = "", alignDefinitionToRow = false }) {
    const [open, setOpen] = useState(false);
    const item = reviewProfileDefinition(profile, kind, reference);
    if (!reference) return null;
    if (!item) return <span className={className}>{reference}</span>;
    const description = item.description || item.title;
    const button = (
        <button
            type="button"
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
            className={`w-fit cursor-pointer justify-self-start border-0 bg-transparent p-0 text-left text-[inherit] text-[color:var(--green)] underline decoration-dotted underline-offset-2 hover:text-[color:var(--ink)] ${className}`.trim()}
        >
            {reference}
        </button>
    );
    const definition = open ? (
        <span
            data-review-profile-definition=""
            className="mt-[2px] block min-w-0 max-w-[72ch] justify-self-start break-words rounded-[2px] border border-[color:var(--line-soft)] bg-[color:var(--control-bg)] px-[7px] py-[5px] text-left text-[11px] leading-[1.4] text-[color:var(--ink)]"
        >
            {item.title && item.title !== description ? <strong className="block font-medium">{item.title}</strong> : null}
            <span>{description}</span>
            {item.basis ? <span className="mt-[2px] block text-[10px] text-[color:var(--muted-soft)]">Basis: {item.basis}</span> : null}
        </span>
    ) : null;
    if (alignDefinitionToRow) return <>{button}{open ? <span data-review-profile-line-break="" className="h-0 basis-full" aria-hidden="true" /> : null}{definition}</>;
    return <span className="inline-grid min-w-0 justify-items-start text-left">{button}{definition}</span>;
}
